// FIXME: Use Constants in Redux instead and remove when the mobile is ready
var GLOBAL_EVENTS = {
  SOCKET_GLOBAL_EVENT_JOIN_ROOM: '@socket-global-event/join-room',
  SOCKET_GLOBAL_EVENT_ROOM_JOINED: '@socket-global-event/room-joined',
  SOCKET_GLOBAL_EVENT_LEAVE_ROOM: '@socket-global-event/leave-room',
  SOCKET_GLOBAL_EVENT_APP_ERROR: '@socket-global-event/app-error'
};
export default {
  GLOBAL_EVENTS: GLOBAL_EVENTS
};